export default "__VITE_ASSET__BUvbfKiq__"